import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, select, put, takeEvery, all } from 'redux-saga/effects';
import { msas } from 'redux/saga/entities/bound';
import { useSellHeader, toggleFlag } from 'redux/modules/page';
import { flagSelector } from 'redux/saga/selectors/page';

export const ctaClick = promoAlias => ({
  type: 'HERO_CTA_CLICK',
  promoAlias,
});

export function* loadSaga(client) {
  yield all([put(useSellHeader()), call(fetchEntityIfNeeded, msas, [client])]);
}

export function* doPostCtaClick() {
  const flags = yield select(flagSelector);

  if (flags.headerDropdownOpen) {
    yield put(toggleFlag('headerDropdownOpen'));
  }
}

export function* watchSaga(client) {
  yield takeEvery(ctaClick().type, doPostCtaClick, client);
}
